(() => {
  if (window.NpsProductStory) return;

  const stories = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const mount = (story) => {
    if (stories.has(story)) return;
    if (story.dataset.motion !== 'true' || reducedMotion.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;

    const reveal = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        reveal.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    const chapters = Array.from(story.querySelectorAll('.nps-product-story__chapter'));
    const chapterStates = new Map();
    const active = new IntersectionObserver((entries) => {
      entries.forEach((entry) => chapterStates.set(entry.target, entry.isIntersecting));
      const current = chapters.find((chapter) => chapterStates.get(chapter));
      if (!current) return;
      chapters.forEach((chapter) => chapter.classList.toggle('is-current', chapter === current));
    }, { rootMargin: '-108px 0px -120px 0px', threshold: 0 });

    story.querySelectorAll('[data-story-reveal]').forEach((node) => reveal.observe(node));
    chapters.forEach((chapter) => active.observe(chapter));
    stories.set(story, { reveal, active });
  };

  const unmount = (story) => {
    const observers = stories.get(story);
    if (!observers) return;
    observers.reveal.disconnect();
    observers.active.disconnect();
    story.querySelectorAll('.is-revealed, .is-current').forEach((node) => node.classList.remove('is-revealed', 'is-current'));
    stories.delete(story);
  };

  const mountWithin = (root) => {
    if (root.matches?.('[data-nps-product-story]')) mount(root);
    root.querySelectorAll('[data-nps-product-story]').forEach(mount);
  };

  window.NpsProductStory = { mountWithin };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountWithin(document), { once: true });
  } else {
    mountWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => mountWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    stories.forEach((_, story) => {
      if (event.target.contains(story)) unmount(story);
    });
  });
  reducedMotion.addEventListener?.('change', () => {
    stories.forEach((_, story) => unmount(story));
    if (!reducedMotion.matches) mountWithin(document);
  });
})();
